import LoginForm from './components/LoginForm';
export default function ClientLoginPage() {
  return <LoginForm role="client" />;
}
